import common from './common/main'

export let civil = {
}

export let practical = {
}

export let architect = {
}

export default {
  common,
  civil,
  practical,
  architect
}
